<template>
  <div class="guideContainer">
    <div class="text" v-if="streamingInfo !== undefined"> {{ streamingInfo.previewmsg }} </div>
    <div class="btnType01 first" @click.prevent="showLogin">로그인</div>
    <div class="btnType01 sec" @click.prevent="showAccount">회원가입</div>
  </div>
</template>

<script>
export default {
  name: 'LoginGuide',
  props: {
    streamingInfo: {
      type: Object
    }
  },
  methods: {
    showLogin () {
      this.$router.push({ name: 'login', query: { referer: this.$route.fullPath } })
    },
    showAccount () {
      let encodeLocationHref = encodeURIComponent(window.location.href)
      location.href = 'https://member.wavve.com/mobile/account?returnurl=' + encodeLocationHref
      // alert('회원가입은 스마트폰을 이용해 wavve 모바일웹(http://familyhub.pooq.co.kr)에서 진행해 주세요.')
    }
  }
}
</script>

<style>
  .guideContainer { width: 100%; position: relative; height: 81px; }
  .guideContainer .text { position: absolute; top:21px; left:20px; color:#a5a5a5; font-size: 14px; width: 270px;}
  .guideContainer .first { position: absolute; top:12px; right:20px;  }
  .guideContainer .sec { position: absolute; top:44px; right:20px;  }
  .btnType01 {  height: 24px; text-align:center; line-height:24px; color: #ffffff; font-size: 12px; border-radius: 12px; border: 1px solid #fff;padding: 0 10px 0 10px;}
</style>
